"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ErrorCodes;
(function (ErrorCodes) {
    ErrorCodes["PARSER_ERROR_MISSING_TEXT"] = "parserErrorMissingText";
    ErrorCodes["PARSER_ERROR_MISSING_SEQUENCE_NUMBER"] = "parserErrorMissingSequenceNumber";
    ErrorCodes["PARSER_ERROR_INVALID_SEQUENCE_NUMBER"] = "parserErrorInvalidSequenceNumber";
    ErrorCodes["PARSER_ERROR_MISSING_TIME_SPAN"] = "parserErrorMissingTimeSpan";
    ErrorCodes["PARSER_ERROR_INVALID_TIME_SPAN"] = "parserErrorInvalidTimeSpan";
    ErrorCodes["PARSER_ERROR_INVALID_TIME_STAMP"] = "parserErrorInvalidTimeStamp";
    ErrorCodes["VALIDATOR_ERROR_START_TIME"] = "validatorErrorStartTime";
    ErrorCodes["VALIDATOR_ERROR_END_TIME"] = "validatorErrorEndTime";
    ErrorCodes["VALIDATOR_ERROR_SEQUENCE_NUMBER_START"] = "validatorErrorSequenceNumberStart";
    ErrorCodes["VALIDATOR_ERROR_SEQUENCE_NUMBER_INCREMENT"] = "validatorErrorSequenceNumberIncrement";
})(ErrorCodes || (ErrorCodes = {}));
exports.default = ErrorCodes;
